var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myfooter"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('hr'),_c('span',[_vm._v("Copyright © 2001-")]),_c('span',[_vm._v(_vm._s(_vm.fullYear))]),_c('span',{attrs:{"id":"coperight"}},[_vm._v(_vm._s(_vm.dataRes.registCompany))]),_c('span',[_vm._v(" All Rights Reserved.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }